<template>
    <div class="door-fit-finder-selection__wrapper">
        <div class="door-fit-finder-selection__text">
            <font-awesome-icon :icon="['fa-thin', 'fa-puzzle']" />
            <h6 class="door-fit-finder-selection__header">{{ displayName }}</h6>
            <p class="door-fit-finder-selection__description">{{ description }}</p>
        </div>
        <SwitchToggle :isSelected="isSelected" @onSwitchChange="onSwitchChange" id="doorFitFinderToggle" />
    </div>
</template>

<script lang="ts">
import SwitchToggle from './shared/SwitchToggle.vue';
import DoorFitFinderModal from "Vue/components/lockDesigner/components/shared/Modals/DoorFitFinderModal.vue";
export default {
    name: 'DoorFitFinderSelection',
    components: {
        SwitchToggle,
        DoorFitFinderModal,
    },
    props: {
        displayName: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        route: {
            type: String,
            default: '',
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        async onSwitchChange(isSelected: boolean) {
            if(isSelected) {
                await this.$store.dispatch('openModal', { component: DoorFitFinderModal });
            } else {
                this.$store.commit('updateSelections', {
                    doorFitFinderEnabled: false
                });
            }
        },
    },
};
</script>
